module.exports = __webpack_public_path__ + "img/pexels-sorry.36cbc923.webp";